<!-- tipo-servico.component.html -->
<div class="n-tipo-servico-container">
  <!-- Indicador de carregamento sem bloquear scroll -->
  @if (loading()) {
  <div class="n-loading-inline" aria-live="polite">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ 'BARDO_SERVICOS.CARREGANDO_TIPOS' | translate }}</span>
  </div>
  }

  @if (categoriaFoco(); as categoria) {
  <!-- ==================== TELA DE DETALHE DA CATEGORIA ==================== -->
  <div class="n-categoria-detalhe">
    <!-- Header Card da Categoria em Destaque -->
    <div class="n-categoria-header-card p-3 border-round-xl surface-card flex flex-column gap-2 mb-2">
      <div class="flex align-items-center justify-content-between">
        <p-button
          icon="pi pi-arrow-left"
          [label]="'BARDO_SERVICOS.VOLTAR_CATEGORIAS' | translate"
          [text]="true"
          severity="secondary"
          size="small"
          (click)="voltarParaListagem()"
        />

        <div class="n-tipo-actions flex align-items-center gap-1">
          @if (possuiPermissao('Bardo.tipos-servico.update')) {
            <p-button
              icon="pi pi-pencil"
              [text]="true"
              [rounded]="true"
              size="small"
              severity="secondary"
              [pTooltip]="'BARDO_SERVICOS.EDITAR_CATEGORIA' | translate"
              (click)="abrirModalEditarTipo(categoria)"
            />
          }
          @if (possuiPermissao('Bardo.tipos-servico.delete')) {
            <p-button
              icon="pi pi-trash"
              [text]="true"
              [rounded]="true"
              size="small"
              severity="danger"
              [pTooltip]="'BARDO_SERVICOS.EXCLUIR_CATEGORIA' | translate"
              (click)="excluirTipoServico(categoria)"
            />
          }
        </div>
      </div>

      <!-- Título da Categoria em Destaque com Ícone -->
      <div class="flex align-items-center gap-3 pt-1">
        <div class="n-avatar flex align-items-center justify-content-center text-white font-bold border-circle flex-shrink-0" style="background-color: #6366F1; width: 44px; height: 44px;">
          <i class="pi pi-folder text-lg text-white"></i>
        </div>
        <div class="flex flex-column min-w-0">
          <span class="text-xs font-bold text-primary uppercase tracking-wider">{{ 'BARDO_SERVICOS.CATEGORIA' | translate }}</span>
          <h2 class="m-0 text-xl font-bold text-color text-overflow-ellipsis overflow-hidden white-space-nowrap">{{ categoria.nome }}</h2>
        </div>
      </div>
    </div>

    <!-- Botão de Cadastrar Novo Serviço e Busca de Serviços -->
    <div class="n-top-section flex flex-column gap-2 mb-2">
      @if (possuiPermissao('Bardo.servicos.create')) {
        <div
          class="n-btn-novo-cliente cursor-pointer flex align-items-center justify-content-between p-3"
          role="button"
          tabindex="0"
          (click)="abrirModalNovoServico(categoria.id)"
          (keydown.enter)="abrirModalNovoServico(categoria.id)"
          (keydown.space)="abrirModalNovoServico(categoria.id); $event.preventDefault()"
        >
          <div class="flex align-items-center gap-2 text-primary font-medium text-sm sm:text-base">
            <i class="pi pi-plus text-primary text-sm font-bold"></i>
            <span>{{ 'BARDO_SERVICOS.CADASTRAR_NOVO' | translate: { termo: $termos().servico.singular.toLowerCase() } }}</span>
          </div>
          <i class="pi pi-chevron-right text-primary text-xs"></i>
        </div>
      }

      <!-- Campo de Busca de Serviços na Categoria -->
      <div class="n-search-box">
        <p-iconfield class="w-full">
          <p-inputicon styleClass="pi pi-search text-primary font-bold" />
          <input
            pInputText
            type="text"
            [ngModel]="pesquisaServico()"
            (ngModelChange)="pesquisaServico.set($event)"
            [placeholder]="$termos().servico.placeholderBusca"
            class="w-full n-input-search"
          />
          @if (pesquisaServico()) {
            <p-inputicon styleClass="pi pi-times cursor-pointer text-500" (click)="pesquisaServico.set('')" />
          }
        </p-iconfield>
      </div>
    </div>

    <!-- Contador de Serviços (Posicionado ABAIXO do campo de busca) -->
    <div class="n-counter-header mb-2 flex align-items-center justify-content-between">
      <span class="text-xs font-bold text-500 uppercase tracking-wider">
        {{ getServicosFiltrados(categoria).length }} {{ getServicosFiltrados(categoria).length === 1 ? ($termos().servico.singular | uppercase) : ($termos().servico.plural | uppercase) }}
      </span>
    </div>

    <div class="n-servicos-grid">
      @if (categoria.servicos && categoria.servicos.length > 0) {
        @for (servico of getServicosPaginados(categoria); track servico.id) {
          <div class="n-servico-card flex w-full align-items-center justify-content-between gap-3 p-3">
            <!-- Conteúdo Principal (Ícone + Nome + Preço/Duração Pílulas) -->
            <div class="flex flex-1 align-items-center gap-3 min-w-0">
              <div class="n-avatar flex align-items-center justify-content-center text-white font-bold border-circle flex-shrink-0" style="background-color: #0EA5E9;">
                <i class="pi pi-cog text-base text-white"></i>
              </div>

              <div class="min-w-0 flex-1 flex flex-column gap-1">
                <h3 class="n-item-nome m-0 text-color text-overflow-ellipsis overflow-hidden white-space-nowrap">
                  {{ servico.nome }}
                </h3>

                <div class="n-pills-row flex align-items-center gap-2 text-xs text-500 mt-1">
                  <span class="n-pill price font-semibold">
                    {{ formatarPreco(servico.valor) }}
                  </span>
                  <span class="n-pill phone">
                    <i class="pi pi-clock text-xs"></i>
                    {{ formatarDuracaoExibicao(servico.duracao) }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Ações -->
            <div class="n-action-container flex align-items-center gap-1 flex-shrink-0">
              @if (possuiPermissao('Bardo.servicos.update')) {
                <p-button
                  icon="pi pi-pencil"
                  [text]="true"
                  [rounded]="true"
                  size="small"
                  severity="secondary"
                  [pTooltip]="'BARDO_SERVICOS.EDITAR' | translate: { termo: $nicho().servico.singular.toLowerCase() }"
                  (click)="abrirModalEditarServico(servico)"
                />
              }
              @if (possuiPermissao('Bardo.servicos.delete')) {
                <p-button
                  icon="pi pi-trash"
                  [text]="true"
                  [rounded]="true"
                  size="small"
                  severity="danger"
                  [pTooltip]="'BARDO_SERVICOS.EXCLUIR' | translate: { termo: $nicho().servico.singular.toLowerCase() }"
                  (click)="excluirServico(servico)"
                />
              }
            </div>
          </div>
        }

        @if (temMaisServicos(categoria)) {
          <div class="n-paginacao col-12 text-center mt-2">
            <p-button
              [label]="'BARDO_SERVICOS.VER_MAIS' | translate"
              icon="pi pi-chevron-down"
              [text]="true"
              size="small"
              (click)="expandirServicos(categoria.id)"
            />
          </div>
        } @else if ((categoria.servicos.length || 0) > 5) {
          <div class="n-paginacao col-12 text-center mt-2">
            <p-button
              [label]="'BARDO_SERVICOS.VER_MENOS' | translate"
              icon="pi pi-chevron-up"
              [text]="true"
              size="small"
              (click)="recolherServicos(categoria.id)"
            />
          </div>
        }
      } @else {
        <div class="n-empty-state col-12 text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
          <i class="pi pi-list text-4xl block mb-2 text-400"></i>
          <h3 class="m-0 text-base font-semibold text-700">{{ 'BARDO_SERVICOS.NENHUM_SERVICO_CADASTRADO' | translate: { termo: $nicho().servico.singular.toLowerCase() } }}</h3>
          <p class="m-0 text-sm text-500 mt-1">{{ 'BARDO_SERVICOS.ADICIONE_PRIMEIRO_SERVICO' | translate: { termo: $nicho().servico.singular.toLowerCase() } }}</p>
        </div>
      }
    </div>
  </div>
  } @else {
  <!-- ==================== LISTAGEM DE CATEGORIAS ==================== -->

  <!-- Top section: Botão Cadastrar Nova Categoria e Campo de Busca -->
  <div class="n-top-section flex flex-column gap-2 mb-2">
    @if (possuiPermissao('Bardo.tipos-servico.create')) {
      <div
        class="n-btn-novo-cliente cursor-pointer flex align-items-center justify-content-between p-3"
        role="button"
        tabindex="0"
        (click)="abrirModalNovoTipo()"
        (keydown.enter)="abrirModalNovoTipo()"
        (keydown.space)="abrirModalNovoTipo(); $event.preventDefault()"
      >
        <div class="flex align-items-center gap-2 text-primary font-medium text-sm sm:text-base">
          <i class="pi pi-plus text-primary text-sm font-bold"></i>
          <span>{{ 'BARDO_SERVICOS.CADASTRAR_NOVA_CATEGORIA' | translate }}</span>
        </div>
        <i class="pi pi-chevron-right text-primary text-xs"></i>
      </div>
    }

    <!-- Campo de Busca de Categorias/Serviços -->
    <div class="n-search-box">
      <p-iconfield class="w-full">
        <p-inputicon styleClass="pi pi-search text-primary font-bold" />
        <input
          pInputText
          type="text"
          [ngModel]="pesquisa()"
          (ngModelChange)="pesquisa.set($event)"
          [placeholder]="$termos().servico.placeholderBusca"
          class="w-full n-input-search"
        />

        @if (pesquisa()) {
          <p-inputicon styleClass="pi pi-times cursor-pointer text-500" (click)="pesquisa.set('')" />
        }
      </p-iconfield>
    </div>
  </div>

  <!-- Contador de Categorias -->
  <div class="n-counter-header mb-2 flex align-items-center justify-content-between">
    <span class="text-xs font-bold text-500 uppercase tracking-wider">
      {{ tiposServicoFiltrados().length }} {{ tiposServicoFiltrados().length === 1 ? ('BARDO_SERVICOS.CATEGORIA' | translate | uppercase) : ('BARDO_SERVICOS.CATEGORIAS' | translate | uppercase) }}
    </span>
  </div>

  <!-- Grid de Cards de Categorias -->
  <div class="n-tipos-grid">
    @for (tipo of tiposServicoFiltrados(); track tipo.id) {
      <div
        class="n-tipo-card flex w-full align-items-center justify-content-between gap-3 p-3 cursor-pointer"
        role="button"
        tabindex="0"
        (click)="abrirCategoria(tipo.id)"
        (keydown.enter)="abrirCategoria(tipo.id)"
      >
        <!-- Conteúdo Principal (Avatar/Ícone + Nome + Contador) -->
        <div class="flex flex-1 align-items-center gap-3 min-w-0">
          <div class="n-avatar flex align-items-center justify-content-center text-white font-bold border-circle flex-shrink-0" style="background-color: #6366F1;">
            <i class="pi pi-folder text-base text-white"></i>
          </div>

          <div class="min-w-0 flex-1 flex flex-column gap-1">
            <h3 class="n-item-nome m-0 text-color text-overflow-ellipsis overflow-hidden white-space-nowrap">
              {{ tipo.nome }}
            </h3>

            <div class="flex flex-wrap align-items-center gap-2 text-xs text-500 mt-1">
              <span class="n-pill count">
                <i class="pi pi-list text-xs"></i> {{ getContadorServicos(tipo) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Indicador de Ação (Ações + Chevron à direita) -->
        <div class="n-action-container flex align-items-center gap-1 flex-shrink-0">
          @if (possuiPermissao('Bardo.tipos-servico.update')) {
            <p-button
              icon="pi pi-pencil"
              [text]="true"
              [rounded]="true"
              size="small"
              severity="secondary"
              [pTooltip]="'BARDO_SERVICOS.EDITAR_CATEGORIA' | translate"
              (click)="abrirModalEditarTipo(tipo)"
            />
          }
          @if (possuiPermissao('Bardo.tipos-servico.delete')) {
            <p-button
              icon="pi pi-trash"
              [text]="true"
              [rounded]="true"
              size="small"
              severity="danger"
              [pTooltip]="'BARDO_SERVICOS.EXCLUIR_CATEGORIA' | translate"
              (click)="excluirTipoServico(tipo)"
            />
          }
          <div class="n-action-circle flex align-items-center justify-content-center border-circle ml-1">
            <i class="pi pi-chevron-right text-400 text-xs"></i>
          </div>
        </div>
      </div>
    } @empty {
      @if (pesquisa()) {
        <div class="n-empty-state text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
          <i class="pi pi-search text-4xl block mb-2 text-400"></i>
          <h3 class="m-0 text-base font-semibold text-700">{{ 'BARDO_SERVICOS.NENHUM_RESULTADO' | translate }}</h3>
          <p class="m-0 text-sm text-500 mt-1">{{ 'BARDO_SERVICOS.NENHUM_RESULTADO_BUSCA' | translate }}</p>
        </div>
      } @else {
        <!-- Empty State Global -->
        <div class="n-empty-state-global text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
          <i class="pi pi-list text-4xl block mb-2 text-400"></i>
          <h3 class="m-0 text-base font-semibold text-700">{{ 'BARDO_SERVICOS.NENHUM_TIPO_CADASTRADO' | translate }}</h3>
          <p class="m-0 text-sm text-500 mt-1">{{ 'BARDO_SERVICOS.COMECE_CRIANDO_CATEGORIAS' | translate }}</p>
          @if (possuiPermissao('Bardo.tipos-servico.create')) {
            <p-button
              [label]="'BARDO_SERVICOS.CRIAR_PRIMEIRA_CATEGORIA' | translate"
              icon="pi pi-plus"
              class="mt-2"
              (click)="abrirModalNovoTipo()"
            />
          }
        </div>
      }
    }
  </div>
  }
</div>

<lib-tipo-servico-form-modal
  [(visible)]="modalCategoriaVisivel"
  [tipoServico]="tipoServicoSelecionado()"
  (salvo)="onModalTipoSalvo($event)"
/>

<lib-servico-form-modal
  [(visible)]="modalServicoVisivel"
  [tipoServicoId]="tipoServicoSelecionado()?.id ?? null"
  [servico]="servicoEdicao()"
  (salvo)="onModalServicoSalvo()"
/>

<!-- Mobile Bottom Sheet para Confirmar Exclusão de Categoria/Tipo -->
@if (deviceService.$isMobile() && modalExclusaoTipoAberto()) {
<lib-bottom-sheet
  [visible]="modalExclusaoTipoAberto()"
  (visibleChange)="modalExclusaoTipoAberto.set($event)"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!excluindoTipo()"
  [closeOnEscape]="!excluindoTipo()"
  [preventClose]="excluindoTipo()"
  [headerTemplate]="headerExcluirTipoTemplate"
  [footerTemplate]="footerExcluirTipoTemplate"
  (hide)="modalExclusaoTipoAberto.set(false)"
>
  <div class="flex flex-column align-items-center text-center py-3 px-2 gap-3">
    <div class="w-3rem h-3rem border-circle bg-red-100 flex align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
    </div>
    <p class="m-0 text-700 text-base line-height-3">
      {{ mensagemExclusaoTipo() }}
    </p>
  </div>
</lib-bottom-sheet>
}

<ng-template #headerExcluirTipoTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg">{{ 'GLOBAL.CONFIRMAR_EXCLUSAO' | translate }}</h3>
  </div>
</ng-template>

<ng-template #footerExcluirTipoTemplate>
  <div class="flex gap-2 w-full pt-2">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full"
      (onClick)="modalExclusaoTipoAberto.set(false)"
      [disabled]="excluindoTipo()"
    />
    <p-button
      [label]="'GLOBAL.SIM_EXCLUIR' | translate"
      severity="danger"
      styleClass="w-full"
      icon="pi pi-trash"
      [loading]="excluindoTipo()"
      (onClick)="confirmarExclusaoTipoConfirmada()"
    />
  </div>
</ng-template>

<!-- Mobile Bottom Sheet para Confirmar Exclusão de Serviço -->
@if (deviceService.$isMobile() && modalExclusaoServicoAberto()) {
<lib-bottom-sheet
  [visible]="modalExclusaoServicoAberto()"
  (visibleChange)="modalExclusaoServicoAberto.set($event)"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!excluindoServico()"
  [closeOnEscape]="!excluindoServico()"
  [preventClose]="excluindoServico()"
  [headerTemplate]="headerExcluirServicoTemplate"
  [footerTemplate]="footerExcluirServicoTemplate"
  (hide)="modalExclusaoServicoAberto.set(false)"
>
  <div class="flex flex-column align-items-center text-center py-3 px-2 gap-3">
    <div class="w-3rem h-3rem border-circle bg-red-100 flex align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
    </div>
    <p class="m-0 text-700 text-base line-height-3">
      {{ 'BARDO_SERVICOS.CONFIRMAR_EXCLUSAO_SERVICO_NOME' | translate: { termo: $nicho().servico.singular.toLowerCase(), nome: servicoParaExcluir()?.nome } }}
    </p>
  </div>
</lib-bottom-sheet>
}

<ng-template #headerExcluirServicoTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg">{{ 'GLOBAL.CONFIRMAR_EXCLUSAO' | translate }}</h3>
  </div>
</ng-template>

<ng-template #footerExcluirServicoTemplate>
  <div class="flex gap-2 w-full pt-2">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full"
      (onClick)="modalExclusaoServicoAberto.set(false)"
      [disabled]="excluindoServico()"
    />
    <p-button
      [label]="'GLOBAL.SIM_EXCLUIR' | translate"
      severity="danger"
      styleClass="w-full"
      icon="pi pi-trash"
      [loading]="excluindoServico()"
      (onClick)="confirmarExclusaoServicoConfirmada()"
    />
  </div>
</ng-template>

<!-- Confirm Dialog -->
<p-confirmDialog />
